import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTable = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M10.91 2.75H1.91003C1.81058 2.75 1.7152 2.78951 1.64487 2.85984C1.57454 2.93016 1.53503 3.02554 1.53503 3.125V9.5C1.53503 9.69891 1.61405 9.88968 1.7547 10.0303C1.89536 10.171 2.08612 10.25 2.28503 10.25H10.535C10.7339 10.25 10.9247 10.171 11.0654 10.0303C11.206 9.88968 11.285 9.69891 11.285 9.5V3.125C11.285 3.02554 11.2455 2.93016 11.1752 2.85984C11.1049 2.78951 11.0095 2.75 10.91 2.75ZM2.28503 5.75H4.16003V7.25H2.28503V5.75ZM4.91003 5.75H10.535V7.25H4.91003V5.75ZM2.28503 8H4.16003V9.5H2.28503V8ZM10.535 9.5H4.91003V8H10.535V9.5Z",
		fill: "currentColor"
	})
});
export default SvgTable;
